import { render, staticRenderFns } from "./MaterialOrderDialog.vue?vue&type=template&id=22dba0e8&"
import script from "./MaterialOrderDialog.vue?vue&type=script&lang=js&"
export * from "./MaterialOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports